<app-navbar></app-navbar>

<div class="premium-3d-list-page py-5">
    <div class="container">
        
        <div class="premium-page-header mb-5 text-center">
            <h1 class="ultimate-3d-title">নোটিশ বোর্ড</h1>
            <div class="premium-header-divider mx-auto mt-3"></div>
        </div>

        <div class="row g-4 justify-content-center">
            <!-- Notice List Side -->
            <div class="col-lg-4 col-md-5">
                <div class="ultimate-3d-card p-4 h-100" style="background: rgba(255, 255, 255, 0.85); border-radius: 24px;">
                    <div style="max-height: 600px; overflow-y: auto; overflow-x: hidden; padding-right: 8px;"
                        class="custom-scrollbar">
                        <div class="d-flex flex-column" style="gap: 12px;">
                            <div class="notice-3d-item d-flex align-items-center p-3 rounded"
                                [ngStyle]="{'background': selectedNotice?.Id === notice.Id ? 'linear-gradient(135deg, #0d8b54, #0f4c3a)' : 'rgba(255, 255, 255, 0.5)'}"
                                *ngFor="let notice of Notices" (click)="showNotice($event, notice)">

                                <!-- Date Box -->
                                <div class="notice-date text-white text-center rounded d-flex flex-column justify-content-center flex-shrink-0"
                                    [ngStyle]="{'background': selectedNotice?.Id === notice.Id ? 'rgba(255, 255, 255, 0.2)' : 'linear-gradient(135deg, #0d8b54, #20c997)'}">
                                    <div class="fw-bold" style="font-size: 22px; line-height: 1;">{{ (notice.CreatedDate |
                                        date:'dd') || '01' }}</div>
                                    <div style="font-size: 11px; font-weight: 600; margin-top: 2px; text-transform: uppercase;">{{ (notice.CreatedDate
                                        | date:'MMM') || 'Jan' }}</div>
                                </div>

                                <!-- Title -->
                                <div class="flex-grow-1 px-3" style="min-width: 0;">
                                    <a class="fw-bold text-decoration-none d-block notice-title-text"
                                        [ngStyle]="{'color': selectedNotice?.Id === notice.Id ? '#ffffff' : '#1e293b'}">
                                        {{ notice.TitleBn || notice.EnglishTitle || 'নোটিশ' }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Notice Viewer Side -->
            <div class="col-lg-8 col-md-7">
                <div class="document-viewer-card h-100 d-flex flex-column">
                    <div *ngIf="selectedNotice; else noNotice" class="d-flex flex-column h-100">
                        <div class="document-header d-flex justify-content-between align-items-center">
                            <div>
                                <h3 class="fw-bold m-0" style="color: #0f4c3a; font-size: 22px;">{{
                                    selectedNotice.TitleBn || selectedNotice.EnglishTitle }}</h3>
                                <div class="mt-2" style="font-size: 14px; color: #64748b; font-weight: 500;">
                                    <i class="fa-regular fa-calendar-alt me-2" style="color: #0d8b54;"></i> {{ selectedNotice.CreatedDate | date:'fullDate'
                                    }}
                                </div>
                            </div>
                            <a [href]="'assets/img/school/notice/' + selectedNotice.FileLink" *ngIf="isImage(selectedNotice.FileLink)" download class="btn btn-sm btn-success rounded-pill px-4" style="background: #0f4c3a; border: none;">
                                <i class="fa-solid fa-download me-2"></i> Download
                            </a>
                        </div>

                        <div class="flex-grow-1 p-0 position-relative"
                            style="background-color: #f8fafc; min-height: 600px;">
                            <img *ngIf="isImage(selectedNotice.FileLink)"
                                [src]="'assets/img/school/notice/' + selectedNotice.FileLink" alt="Notice"
                                class="img-fluid w-100 h-100 object-fit-contain p-4" />

                            <div *ngIf="!isImage(selectedNotice.FileLink)" class="w-100 h-100">
                                <iframe class="viewport w-100 h-100" style="min-height: 600px;" frameBorder="0"
                                    [src]="urlSafe"></iframe>
                            </div>
                        </div>
                    </div>

                    <ng-template #noNotice>
                        <div class="d-flex flex-column align-items-center justify-content-center h-100 text-center p-5"
                            style="min-height: 600px;">
                            <i class="fa-regular fa-folder-open mb-4" style="font-size: 64px; color: #cbd5e1;"></i>
                            <h3 style="color: #64748b; font-weight: 700;">কোন নোটিশ নির্বাচিত হয়নি</h3>
                            <p style="font-size: 16px; color: #94a3b8; max-width: 300px; margin: 15px auto;">বিস্তারিত দেখতে বাম পাশ থেকে একটি নোটিশ নির্বাচন করুন।</p>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .notice-item-hover:hover {
        background-color: #eef2f6 !important;
        transform: translateX(4px);
    }

    .custom-scrollbar::-webkit-scrollbar {
        width: 4px;
    }

    .custom-scrollbar::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb {
        background: #cbd5e1;
        border-radius: 4px;
    }

    .custom-scrollbar::-webkit-scrollbar-thumb:hover {
        background: #94a3b8;
    }
</style>